import { freddyTheme } from '@coolblue-development/freddy';
import { containerHeight } from '../constants.js';
export const getContainerStyles = ({ isOverlay }) => ({
    position: 'relative',
    height: isOverlay ? '100%' : 'auto',
    flexDirection: 'column',
    gap: freddyTheme.spacing[400],
    '& img': {
        width: '100%',
    },
});
export const getGalleryItemStyles = ({ size, openModalOnClick, }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    cursor: openModalOnClick ? 'pointer' : 'initial',
    '> div': {
        width: '100%',
    },
    ...(typeof size === 'string' && {
        height: containerHeight[size],
        img: {
            maxHeight: containerHeight[size],
        },
    }),
    ...(typeof size === 'object' && {
        height: containerHeight[size['xs']],
        img: {
            maxHeight: containerHeight[size['xs']],
        },
        ...['sm', 'md', 'lg', 'xl'].reduce((styles, breakpoint) => {
            return {
                ...styles,
                ...(size[breakpoint] && {
                    [freddyTheme.breakpoint.minWidth(breakpoint)]: {
                        height: containerHeight[size[breakpoint]],
                        img: {
                            maxHeight: containerHeight[size[breakpoint]],
                        },
                    },
                }),
            };
        }, {}),
    }),
});
//# sourceMappingURL=MediaGalleryContent.styles.js.map